export default class AnonAuthenticateRequest {
    agencyId: string;
    accessToken: string;
}